/**
 * Switches the founder's presence on the marketing page: the Founder section,
 * the "your demo is with Vasco" strip in the demo drawer and the founder's
 * avatar in the chat header. Off until there is a photo.
 *
 * Turning it on: also move the chat, FAQ-signature and footer-support copy in
 * each locale's site.json from "the team" to first person (commit 7babe3fe
 * has the wording in all seven locales).
 */
export const SHOW_FOUNDER = false;
